module.exports = __webpack_public_path__ + "img/linkedin-logo.3e669321.svg";